import {
	Box,
	Button,
	FormControl,
	FormLabel,
	HStack,
	Portal,
	useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import Icon from "../icon/Icon";
import { Pencil } from "../icons/Icons";
import "./styles.scss";

type Props = {
	children: React.ReactNode;
	label: string;
};

const SidebarDrawer = (props: Props) => {
	const { onClose, isOpen, onToggle } = useDisclosure();
	const containerRef = React.useRef<HTMLDivElement>(
		document.querySelector(".interface-interface-skeleton__content")
	);
	return (
		<FormControl>
			<HStack justify="space-between">
				<FormLabel>{props.label}</FormLabel>

				<Button variant="icon" onClick={onToggle}>
					<Box
						w="5"
						h="5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						bgColor="gray.100"
						borderRadius="sm"
						sx={{
							svg: {
								fill: "gray.400",
								w: "4",
								h: "4",
							},
						}}
						border={isOpen ? "1px" : undefined}
						borderColor="primary.500"
					>
						<Pencil />
					</Box>
				</Button>
			</HStack>
			<Portal containerRef={containerRef}>
				{isOpen && (
					<>
						<Box
							pos="absolute"
							top={"0"}
							bottom={"0"}
							right={"67"}
							w={"280px"}
							zIndex={2}
							background="white"
							height="max-content"
						>
							<Box
								position={"fixed"}
								background="white"
								borderLeft="1px solid"
								borderTop="1px solid"
								borderBottom="1px solid"
								borderColor="#E0E0E0"
								backdropBlur={12.5}
							>
								<HStack justify="flex-end">
									<Button
										variant="link"
										pos="relative"
										top={"0"}
										bottom={"0"}
										right={"0"}
										p={"10px"}
										onClick={onClose}
									>
										<Icon
											type="controlIcon"
											name="close"
											size={15}
										/>
									</Button>
								</HStack>
								{props.children}
							</Box>
							<Box
								onClick={onClose}
								pos="absolute"
								zIndex="1"
								top={0}
								left={0}
								right={0}
								bottom={0}
							/>
						</Box>
					</>
				)}
			</Portal>
		</FormControl>
	);
};

export default SidebarDrawer;
